(function () {
  'use strict';

  if (window.LuxProductViewersBadge) {
    window.LuxProductViewersBadge.init();
    return;
  }

  var GALLERY_SELECTORS = [
    '.productView-images-wrapper',
    '.productView-image-wrapper',
    '.productView-media',
    '.productView-gallery',
    '[data-product-gallery]',
    '[data-product-media-gallery]',
    '.productView-images',
    '.productView-image',
    '.product__media-wrapper',
    '.product-single__media-group',
    '.halo-productView-left',
    '.productView-left'
  ];

  function safeStorageGet(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  }

  function safeStorageSet(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      /* El badge seguirá funcionando sin sessionStorage. */
    }
  }

  function isVisible(element) {
    if (!element) return false;

    var styles = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();

    return (
      styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      rect.width > 180 &&
      rect.height > 180
    );
  }

  function normalizeAnchor(element) {
    if (!element) return null;

    var tagName = element.tagName
      ? element.tagName.toLowerCase()
      : '';

    if (
      tagName === 'img' ||
      tagName === 'video' ||
      tagName === 'picture'
    ) {
      return element.parentElement;
    }

    return element;
  }

  function findGalleryAnchor() {
    var bestAnchor = null;
    var bestArea = 0;

    GALLERY_SELECTORS.forEach(function (selector) {
      document.querySelectorAll(selector).forEach(function (candidate) {
        candidate = normalizeAnchor(candidate);

        if (!isVisible(candidate)) return;

        var rect = candidate.getBoundingClientRect();
        var area = rect.width * rect.height;

        /*
         * Priorizamos el contenedor visible más grande
         * de la galería principal.
         */
        if (area > bestArea) {
          bestAnchor = candidate;
          bestArea = area;
        }
      });
    });

    return bestAnchor;
  }

  function getRandomInteger(minimum, maximum) {
    minimum = parseInt(minimum, 10) || 3;
    maximum = parseInt(maximum, 10) || 8;

    if (maximum < minimum) {
      maximum = minimum;
    }

    return Math.floor(
      Math.random() * (maximum - minimum + 1) + minimum
    );
  }

  function getViewerCount(badge, productId) {
    var countKey =
      'lux-viewers-count-v1-' + String(productId);

    var storedCount = parseInt(
      safeStorageGet(countKey),
      10
    );

    if (storedCount > 0) {
      return storedCount;
    }

    var minimum = badge.getAttribute(
      'data-min-viewers'
    );

    var maximum = badge.getAttribute(
      'data-max-viewers'
    );

    var newCount = getRandomInteger(
      minimum,
      maximum
    );

    safeStorageSet(
      countKey,
      String(newCount)
    );

    return newCount;
  }

  function mountBadge(badge) {
    var anchor = findGalleryAnchor();

    if (!anchor) return false;

    anchor.classList.add(
      'lux-product-viewers-anchor'
    );

    anchor.appendChild(badge);

    return true;
  }

  function showBadge(badge, productId) {
    var countElement = badge.querySelector(
      '[data-lux-viewers-count]'
    );

    if (!countElement) return;

    countElement.textContent = String(
      getViewerCount(badge, productId)
    );

    badge.hidden = false;

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        badge.classList.add('is-visible');
      });
    });

    safeStorageSet(
      'lux-viewers-shown-v1-' + String(productId),
      'true'
    );
  }

  function startVisibleTimer(
    badge,
    productId,
    delay
  ) {
    var elapsedVisibleTime = 0;
    var previousTimestamp = Date.now();

    var timer = window.setInterval(function () {
      var currentTimestamp = Date.now();
      var elapsedSinceLastCheck =
        currentTimestamp - previousTimestamp;

      previousTimestamp = currentTimestamp;

      /*
       * Solo contamos el tiempo cuando el usuario
       * está viendo realmente la pestaña.
       */
      if (document.visibilityState === 'visible') {
        elapsedVisibleTime += elapsedSinceLastCheck;
      }

      if (elapsedVisibleTime < delay) return;

      window.clearInterval(timer);

      /*
       * Volvemos a localizar la galería por si el tema
       * la ha reconstruido al cambiar la variante.
       */
      mountBadge(badge);
      showBadge(badge, productId);
    }, 250);
  }

  function initBadge(badge) {
    if (badge.dataset.initialized === 'true') {
      return;
    }

    badge.dataset.initialized = 'true';

    var productId =
      badge.getAttribute('data-product-id');

    if (!productId) return;

    var shownKey =
      'lux-viewers-shown-v1-' + String(productId);

    /*
     * No vuelve a aparecer para el mismo producto
     * durante esta sesión.
     */
    if (safeStorageGet(shownKey) === 'true') {
      return;
    }

    var delay =
      parseInt(
        badge.getAttribute('data-delay'),
        10
      ) || 20000;

    /*
     * La galería puede tardar unas décimas en ser
     * creada por el tema. Probamos varias veces.
     */
    var attempts = 0;

    var mountingTimer = window.setInterval(function () {
      attempts += 1;

      if (mountBadge(badge) || attempts >= 2) {
        window.clearInterval(mountingTimer);
      }
    }, 300);

    mountBadge(badge);

    startVisibleTimer(
      badge,
      productId,
      delay
    );
  }

  function init() {
    document
      .querySelectorAll('[data-lux-viewers-badge]')
      .forEach(initBadge);
  }

  window.LuxProductViewersBadge = {
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init
    );
  } else {
    init();
  }

  document.addEventListener(
    'shopify:section:load',
    init
  );
})();